<template>
  <tg-layout>
     <template slot="header">
      <tg-search-tool  
        v-if="$user.group > 70"
        @on-submit="handleSearch">
        <el-input
          :placeholder="$t('column.l70_account')"
          v-model="searchData.username"
          class="tg-input input-search-username"
          size="small"
          clearable
        ></el-input>
      </tg-search-tool>

      <tg-amount-bar
        ref="amount"
        v-show="showAmount"
        :columns="amountColumns"
        :row="amountTotalData"
      ></tg-amount-bar>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      showPagination
      :summary-method="parseSummary"
      showSummary
      :filterMethods="filterMethods"
      :sortMethods="sortMethods"
      @on-loaded="handleLoaded"
      @filter-change="handleFilterChange"
    >
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name v-bind="scope"></tg-user-full-name>
      </template>
      <template slot="note" slot-scope="scope">
        <span>{{ scope.row.note }} </span><br>
        <span v-if="scope.row.same_type !=null && scope.row.same_type < 99" :class="{ 'text-red': true }">
          {{ $t("component.label.same_type["+scope.row.same_type+"]") }}
        </span>
      </template>
    </tg-table>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgAmountBar from "@/components/amount/TgAmountBar";

import { summary } from "@/utils/table";
import apis from "@/apis";
const api = apis.game.bet;

export default {
  components: {
    TgLayout,
    TgTable,
    TgUserFullName,
    TgSearchTool,
    TgAmountBar,
  },
  data() {
    return {
      columns: [],
      proxy: api.getData,
      amountData: {},
      amountTotalData: {},
      filterMethods: {
        tradeContent: this.handleFilter,
      },
      sortMethods: {
        dealmoney: this.sortData("dealmoney"),
      },
      searchData: {
        username: "",
        filter:"",
      },
      isSearch: false,
      showAmount: false,
      hasSearch:false,
      amountColumns: [],
      filters:[],
    };
  },
  props: {
    row: Object,
    column: Object,
    isHistory: Boolean,
  },
  created() {
    this.$store.commit("breadcrumb/clear");
    if (!this.row) {
      this.$router.push({ name: "game.invest" });
    }
    this.addBreadcrumb();
    api.getColumns({ type: this.isHistory ? 2 : 1 ,marketType: this.marketType }).then((response) => {
      this.columns = response.data.columns;
      this.filters = response.data.filters;
      let columns = JSON.parse(JSON.stringify(this.columns));
      columns[3] = {
        ...columns[3],
        filters: this.filters,
        "filter-multiple": false
      };
      this.columns = columns;
      if(this.isHistory){
        this.amountColumns = [];
        this.amountColumns.push(this.columns[4]);
        this.amountColumns.push(this.columns[6]);
      }else{
        this.amountColumns = [];
        this.amountColumns.push(this.columns[4]);
      }
      this.$nextTick(() => {
        this.$refs.table.init(this.request);
      });
    });
  },
  computed: {
    request() {
      return {
        gameId: this.row.game_id,
        gameName: this.row.game_name,
        gameTime:  (this.row.origin_gameTime) ? this.row.origin_gameTime :  this.row.game_time,
        marketType: this.marketType,
        type: this.isHistory ? 2 : 1,
        username: this.searchData.username,
        filter: this.searchData.filter
      };
    },
    marketType() {
      return this.column.marketType;
    },
    /**
     * 解析合計資訊
     */
    parseSummary() {
      let data = this.amountData ? [this.amountData] : [];

      return () => {
        return summary(
          this.columns,
          data,
          this.$t("component.table.summary"),
          3
        );
      };
    },
  },
  methods: {
    handleSearch() {
      let ElTable = this.$refs.table.$refs.ElTable;
      let ElColumns = ElTable.store.states.originColumns;
      let ElColumnIndex = ElColumns.findIndex(x => x.columnKey == 'tradeContent');
      
      // 透過重設columns的參數來初始化篩選值，以讓倒三角形恢復白色
      ElColumns[ElColumnIndex].filteredValue = [];
      
      // 利用觸發篩選的方式來查詢
      // 1. 刷新篩選項目
      // 2. 統一由handleFilterChange處理查詢
      ElTable.store.commit('filterChange', {
        column: ElColumns[ElColumnIndex],
        values: []
      });
    },
    addBreadcrumb() {
      this.$store.commit("breadcrumb/add", {
        name: this.$route.name,
        id: this.$route.name + "_" + this.row.name,
        meta: {
          title: this.row.name,
        },
      });
    },
    handleLoaded(response) {
      this.showAmount =
        response.data.length > 0 && !("length" in response.amount);

      this.amountData = response.amount;
      this.amountTotalData = response.total;
    },
    handleFilter() {
      return true;
    },
    handleFilterChange(filter) {
      if (Object.values(filter).some(x => x.length > 0)) {
          this.searchData.filter = filter.tradeContent[0][1];
      }else{
          this.searchData.filter = 0;
      }
      this.$nextTick(() => {
        this.$refs.table.search(this.request);
      });
    },
    sortData(column) {
      return (a, b) => {
        return a[column] - b[column];
      };
    },
    headerHeight() {
      return !this.showAmount ? 100 : 160;
    },
  },
  watch: {
    showAmount() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
  },
};
</script>
